import Image from "next/image";
import { ContentItemWithImage } from "~/components/ContentItemWithImage";
import { PostListBlock } from "~/components/Sidecar/sidecar-schemas";
import {
  getRouteFromPostType,
  PostToRoutePostTypes,
} from "~/lib/shared/getRouteFromPostType";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";
import { sanitizeRelativeUrl } from "~/lib/shared/sanitizeRelativeUrl";
import { Body, Headline, Link } from "~/ui-library";
import { ChevronRightIcon } from "~/ui-library/icons";

export type PostListSidecarProps = PostListBlock;

export const PostListSidecar: React.FC<PostListSidecarProps> = ({
  optionalCta,
  relatedContent,
  title,
}) => (
  <>
    {!!title && (
      <Headline className="mb-s" level={3} mdLevel={4} as="h3">
        {title}
      </Headline>
    )}
    {relatedContent.length === 1 && (
      <div>
        <ContentItemWithImage
          imagePosition="top"
          imageSrc={getValueOrDefault(
            relatedContent[0].content.image?.source,
            ""
          )}
          headline={relatedContent[0].content.title}
          headlineHref={getRouteFromPostType(
            relatedContent[0].content.type,
            relatedContent[0].content.slug
          )}
        />
      </div>
    )}
    {relatedContent.length > 1 && (
      <ul>
        {relatedContent.map(({ bulletImage, content }) => (
          <li
            key={`post-${content.slug}`}
            className="flex items-center not-last-child:mb-xs"
          >
            {!!bulletImage && (
              <div className="mr-xs h-l w-full max-w-l">
                <Image
                  alt=""
                  className="h-full w-full rounded-[50%]"
                  src={bulletImage}
                  width={32}
                  height={32}
                />
              </div>
            )}
            <Body
              as={Link}
              size="large"
              mdSize="small"
              className="mb-xxs pt-xxs text-gray-800 last:mb-0"
              href={getRouteFromPostType(
                content.type as PostToRoutePostTypes,
                content.slug
              )}
            >
              {content.title}
            </Body>
          </li>
        ))}
      </ul>
    )}
    {!!optionalCta && (
      <div className="mt-xs flex justify-end">
        <Link
          href={sanitizeRelativeUrl(optionalCta.url)}
          className="flex w-fit gap-xxs"
          endAdornmentIcon={ChevronRightIcon}
        >
          <Body size="large" mdSize="small">
            {optionalCta.title}
          </Body>
        </Link>
      </div>
    )}
  </>
);
